import React, { useEffect, useState } from "react";

/**
 * Componente AutoScaler
 * Normaliza y gestiona el comportamiento responsivo del layout en pantallas
 * desde laptops (1280x720) hasta monitores de alta resolución (2K, 4K, 8K y Ultrawide).
 */
const AutoScaler = ({ children }) => {
  const [screenWidth, setScreenWidth] = useState(() => 
    typeof window !== "undefined" ? window.innerWidth : 1920
  );

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div
      className="autoscaler-root"
      data-screen-width={screenWidth}
      style={{
        width: "100%",
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {children}
    </div>
  );
};

export default AutoScaler;
